/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { isString } from 'lodash';

import { Props } from './props';

export const DisplayTextField: React.FC<Props> = (props) => {
  const {
    label,
    value,
    labelProps,
    valueProps,
    type = 'text',
    ...rest
  } = props;
  return (
    <Box>
      <Typography
        variant="subtitle1"
        fontWeight={500}
        fontSize={12}
        color="secondary"
        {...labelProps}
      >
        {label}
      </Typography>
      {type !== 'custom' || isString(value) ? (
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 14,
          }}
          color="text.primary"
          {...valueProps}
        >
          {value}
        </Typography>
      ) : (
        value
      )}
    </Box>
  );
};

export default DisplayTextField;
